import { cn } from "@trendmap/ui/lib/utils";

interface ContainerProps extends React.ComponentPropsWithoutRef<"div"> {
  constrained?: boolean;
}

export function Container({
  className,
  constrained,
  ...props
}: ContainerProps) {
  return (
    <div
      className={cn(
        // "2xl:container p-0",
        constrained && "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8",
        className,
      )}
      {...props}
    />
  );
}
